import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as watchlistAPI from "../../../actions/zoomboard/watchlistManager";
import FormWrapper from "../../common/form/FormWrapper";
import Form from "../../common/form/Form";
import validator from "../../../utils/validator";
import FormField from "../../common/form/FormField";
import Input from "@mui/material/Input";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";

function WatchlistManagerAddMember({ watchlistAPI, onClose, members = [] }) {
  const [submission, setSubmission] = useState(false);
  const [errors, setErrors] = useState({});
  const [fields, setFields] = useState({
    name: "",
    email: "",
    type: "other",
    notes: "",
  });

  const onFieldChange = (event) => {
    const { name, value } = event.target;
    setFields(prev => ({ ...prev, [name]: value }));
  }

  const validate = () => {
    const existingEmails = members.map((member) => normalizeEmail(member.email));
    const checkFields = { ...fields, email: normalizeEmail(fields.email) };

    const rules = [
      { rule: validator.rules.MATCHES_PATTERN, prop: "name", against: validator.patterns.NAME, empty: true },
      { rule: validator.rules.IS_DEFINED, prop: "name" },
      { rule: validator.rules.NOT_IN_LIST, prop: "email", against: existingEmails, empty: true },
      { rule: validator.rules.MATCHES_PATTERN, prop: "email", against: validator.patterns.EMAIL, empty: true },
      { rule: validator.rules.IS_DEFINED, prop: "email" }
    ];
    
    const validationErrors = validator.validate(checkFields, rules);
    if (validationErrors) {
      setErrors(validationErrors);
      return false;
    }
    return true;
  }

  function normalizeEmail(email = "") {
    return email.trim().toLowerCase();
  }

  async function onSubmit(event) {
    event.preventDefault();

    if (!validate()) return;
    setSubmission(true);
    setErrors({});
    
    const created = await watchlistAPI.createWatchlistMember({
      ...fields,
      email: normalizeEmail(fields.email)
    });

    if (!created) {
      setSubmission(false);
      return;
    }

    onClose();
  }

  return (
    <div className="WatchlistManager-overlay">
      <div className="WatchlistManager-form">
        <FormWrapper squared={true} raised={true}>
          <h2>Add Member to Watchlist</h2>
          <Form 
            id="MemberCreate-form"
            onSubmit={onSubmit}
            onClickSecondary={onClose}
            submitLabel="Create" 
            submission={submission} 
            autoComplete="off"
          >
            <FormField fieldName="name" label="Name*" error={validator.message(errors["name"], "name")}>
              <Input
                className="input-margin"
                name="name"
                placeholder="Name" 
                value={fields.name}
                onChange={onFieldChange}
                error={validator.isDefined(errors["name"])}
              />
            </FormField>

            <FormField fieldName="email" label="Email*" error={validator.message(errors["email"], "email")}>
              <Input
                className="input-margin"
                name="email"
                placeholder="Email"
                value={fields.email}
                onChange={onFieldChange}
                error={validator.isDefined(errors["email"])}
              />
            </FormField>
            
            <FormField fieldName="type" label="Type of Member">
              <Select name="type" value={fields.type} onChange={onFieldChange}>
                <MenuItem value="other">Other</MenuItem>
                <MenuItem value="board-member">Board Member</MenuItem>
                <MenuItem value="ecclesiastical-board-member">Ecclesiastical Board Member</MenuItem>
                <MenuItem value="long-time-member">Long-time Member</MenuItem>
                <MenuItem value="large-donor">Large Donor</MenuItem>
              </Select>
            </FormField>

            <FormField fieldName="notes" label="Notes">
              <Input
                className="input-margin"
                name="notes"
                placeholder="Notes"
                value={fields.notes}
                onChange={onFieldChange}
              />
            </FormField>
          </Form>
        </FormWrapper>
      </div>
    </div>
  )
}

WatchlistManagerAddMember.propTypes = {
  members: PropTypes.array,
  onClose: PropTypes.func
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    watchlistAPI: bindActionCreators(watchlistAPI, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WatchlistManagerAddMember);